import type { AasApiAdapter } from "./adapter";
import { requestJson } from "./http";
import { agentsApi } from "./httpAdapter/agents";
import { apiKeysApi } from "./httpAdapter/apiKeys";
import { approvalsApi } from "./httpAdapter/approvals";
import { authApi } from "./httpAdapter/auth";
import { conversationsApi, mapConversationSummary } from "./httpAdapter/conversations";
import { providersApi } from "./httpAdapter/customProviders";
import { deploymentsApi } from "./httpAdapter/deployments";
import { egressApi } from "./httpAdapter/egress";
import { mcpApi } from "./httpAdapter/mcp";
import { modelsApi } from "./httpAdapter/models";
import { profileFilesApi } from "./httpAdapter/profileFiles";
import { replaysApi } from "./httpAdapter/replays";
import { mapSandboxClass, sandboxClassesApi } from "./httpAdapter/sandboxClasses";
import { sessionsApi } from "./httpAdapter/sessions";
import { settingsApi } from "./httpAdapter/settings";
import { toIsoDateTime, usageQueryParams } from "./httpAdapter/shared";
import { slackBotApi } from "./httpAdapter/slackBot";
import { mapTrigger, mapTriggerRun, triggersApi } from "./httpAdapter/triggers";
import { usageApi } from "./httpAdapter/usage";

export const httpApiAdapter: AasApiAdapter = {
	version: () => requestJson("/api/version"),
	auth: authApi,
	agents: agentsApi,
	approvals: approvalsApi,
	agentFiles: profileFilesApi,
	sandboxClasses: sandboxClassesApi,
	deployments: deploymentsApi,
	triggers: triggersApi,
	slackBot: slackBotApi,
	replays: replaysApi,
	models: modelsApi,
	conversations: conversationsApi,
	sessions: sessionsApi,
	egress: egressApi,
	mcp: mcpApi,
	providers: providersApi,
	apiKeys: apiKeysApi,
	usage: usageApi,
	settings: settingsApi,
};

export const __test__ = {
	mapConversationSummary,
	mapSandboxClass,
	mapTrigger,
	mapTriggerRun,
	toIsoDateTime,
	usageQueryParams,
};
